import React from 'react';
import ReactDOM from 'react-dom';
import App from './App/App';

import 'normalize.css';
import './Components/header/styles/css/custom.css';

import { BrowserRouter as Router } from 'react-router-dom';

ReactDOM.render(
  <Router>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Router>,
  document.getElementById('root')
);
